import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';

const ChartSeason = ({ data, title }) => {
  
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data) {
      const color = ['#478FC2'];

      const option = {
        animation: false,
        legend: {
          textStyle: { fontSize: 10 },
          itemStyle: { opacity: 0 },
          data: [{
            name: title[0],
            lineStyle: { color: color[0] },
          }]
        },
        grid: {
          top: 10,
          right: 10,
          bottom: 20,
          left: 10
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            interval: Math.round(data.x.length/6),
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10,
            formatter: (value) => {
              return value.substring(0, 2) + '.' + value.substring(2, 4)
            }
          },
          data: data.x
        },
        yAxis: 
        {
          show: false,
          type: 'value',
          axisLabel: {
            fontSize: 10,
          }
        },
        series: [
          {
            name: title[0],
            data: data.y,
            type: 'line',
            symbol: 'none',
            itemStyle: { color: color[0], borderWidth: 1 },
            lineStyle: { color: color[0], width: 1 },
            z: 6,
            markPoint: {
              data: data.z
            },
          }
        ]
      }
      setOptions(option);
    }
  }, [data, title]);

	return (
    <div className="chart">
      <div style={{width: '100%', height: '200px'}}>
        { options && 
          <ECharts option={options} style={{ width: '100%', height: '100%' }} />
        }
      </div>
    </div>
  );
}

export default ChartSeason;
